import styles from "./TextInput.module.css";

const TextInput = () => {
  return (
    <div className={styles.textInput}>
      <div className={styles.placeholder}>Placeholder</div>
    </div>
  );
};

export default TextInput;
